import React, { useState } from "react";
import styles from "./AdminPanel.module.scss";
import CollectionManager from "./CollectionManager/CollectionManager";

const collections = ["propiedad"];

export const AdminPanel = () => {
  const [activeTab, setActiveTab] = useState(collections[0]);

  return (
    <div className={styles.adminPanel}>
      <div className={styles.sidebar}>
        {collections.map((collection) => (
          <button
            key={collection}
            className={activeTab === collection ? styles.active : ""}
            onClick={() => setActiveTab(collection)}
          >
            {collection}
          </button>
        ))}
      </div>
      <div className={styles.content}>
        <h2>Managing {activeTab}</h2>
        <CollectionManager activeCollection={activeTab} />
      </div>
    </div>
  );
};
